import metaData from "~/data/seo/seo.json";

export interface MetaData {
  enMetaTitle: string;
  guMetaTitle: string;
  enMetaDescription: string;
  guMetaDescription: string;
  enOgTitle: string;
  guOgTitle: string;
  enOgDescription: string;
  guOgDescription: string;
  ogImage: string | null;
  ogImageWidth: string | null;
  ogImageHeight: string | null;
}

type MetaPages = keyof typeof metaData;

export function getPageMeta(page: MetaPages, lang: string) {
  const defaults = metaData.default as MetaData;
  const pageMeta = metaData[page] as MetaData;

  // Merge defaults with page-specific meta
  const merged: MetaData = { ...defaults, ...pageMeta };

  // Return only fields for the specified language + OG fields
  return {
    metaTitle: lang === "en" ? merged.enMetaTitle : merged.guMetaTitle,
    metaDescription: lang === "en" ? merged.enMetaDescription : merged.guMetaDescription,
    ogTitle: lang === "en" ? merged.enOgTitle : merged.guOgTitle,
    ogDescription: lang === "en" ? merged.enOgDescription : merged.guOgDescription,
    ogImage: merged.ogImage,
    ogImageWidth: merged.ogImageWidth,
    ogImageHeight: merged.ogImageHeight,
  };
}
